(function(){
  'use strict';

  AOS.init({
      once: true,
      duration: 900,
      offset: 120
  });

})();
// Create's 'Implied Consent' EU Cookie Law Banner v:2.4
// Conceived by Robert Kent, James Bavington & Tom Foyster
// Put into a namespace and by Bjørn Rosell
//   Also changed behaviour so you have to click accept to make the banner stay away.
//   To make it behave like the original, set "createCookieWhenBannerIsShown" to true.
var CookieBanner = (function() {
  return {
      'createCookieWhenBannerIsShown': false,
      'createCookieWhenAcceptIsClicked': true,
      'cookieDuration': 30,                   // Number of days before the cookie expires, and the banner reappears
      'cookieName': 'cookieConsent',          // Name of our cookie
      'cookieValue': 'accepted',              // Value of cookie

      '_createDiv': function(html) {
          var bodytag = document.getElementsByTagName('body')[0];
          var div = document.createElement('div');
          div.setAttribute('id','cookie-law');
          div.innerHTML = html;

          // bodytag.appendChild(div); // Adds the Cookie Law Banner just before the closing </body> tag
          // or
          bodytag.insertBefore(div,bodytag.firstChild); // Adds the Cookie Law Banner just after the opening <body> tag

          document.getElementsByTagName('body')[0].className+=' cookiebanner'; //Adds a class tothe <body> tag when the banner is visible

          if (CookieBanner.createCookieWhenBannerIsShown) {
              CookieBanner.createAcceptCookie();
          }
      },

      '_createCookie': function(name, value, days) {
          var expires;
          if (days) {
              var date = new Date();
              date.setTime(date.getTime()+(days*24*60*60*1000));
              expires = "; expires="+date.toGMTString();
          }
          else {
              expires = "";
          }
          document.cookie = name+"="+value+expires+"; path=/";
      },

      '_checkCookie': function(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for(var i=0;i < ca.length;i++) {
              var c = ca[i];
              while (c.charAt(0)==' ') c = c.substring(1,c.length);
              if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
          }
          return null;
      },

      '_eraseCookie': function(name) {
          CookieBanner._createCookie(name,"",-1);
      },

      'createAcceptCookie': function() {
          CookieBanner._createCookie(CookieBanner.cookieName, CookieBanner.cookieValue, CookieBanner.cookieDuration); // Create the cookie
      },

      'closeBanner': function() {
          var element = document.getElementById('cookie-law');
          element.parentNode.removeChild(element);
      },

      'accept': function() {
          CookieBanner.createAcceptCookie();
          CookieBanner.closeBanner();
      },

      'showUnlessAccepted': function(html) {
          //alert(CookieBanner._checkCookie(CookieBanner.cookieName));
          //alert(document.cookie);
          if(CookieBanner._checkCookie(CookieBanner.cookieName) != CookieBanner.cookieValue){
              //CookieBanner._createDiv(html);
          }
      }

  }

})();

window.onload = function(){
  //var html = '<p>Our website uses cookies. By continuing we assume your permission to deploy cookies, as detailed in our <a href="/privacy-cookies-policy/" rel="nofollow" title="Privacy &amp; Cookies Policy">privacy and cookies policy</a>. <a class="close-cookie-banner" href="javascript:void(0);" onclick="CookieBanner.accept();"><span>X</span></a></p>'
  var html = '<div>' +
      'By using this website, you agree to our use of cookies. We use cookies to provide you with a great experience and to help our website run effectively. ' +
      'For further information, please review our ' +
      '<a href="/policies/privacy-policy" name="Read Social Expmnt’s Privacy Policy">Privacy Policy</a>.' +
      '</div>'

  // Add the accept button
  html += '<div><a href="javascript:void(0);" onclick="CookieBanner.accept();" class="btn"><span>Got it</span></a></div>';

  CookieBanner.showUnlessAccepted(html);
}
document.addEventListener("DOMContentLoaded", function() {
  const mobileQuery = window.matchMedia("(max-width: 768px)"); // Example breakpoint for mobile

  function handleAccordionClick() {
    document.querySelectorAll(".collapsible-trigger").forEach(trigger => {
      trigger.addEventListener("click", function() {
        // Timeout to allow for the accordion to finish expanding
        setTimeout(() => {
          const accordionId = this.getAttribute("aria-controls");
          const accordionContent = document.getElementById(accordionId);

          if (accordionContent) {
            const accordionBottomPos = accordionContent.getBoundingClientRect().bottom;
            const viewportHeight = window.innerHeight;
            const stickySectionHeight = document.querySelector(".product-cta").clientHeight;

            // Check if the bottom of the accordion is beneath the sticky section
            if (accordionBottomPos > viewportHeight - stickySectionHeight) {
              window.scrollBy({
                top: accordionBottomPos - viewportHeight + stickySectionHeight + 50, // +50 for extra spacing
                behavior: "smooth"
              });
            }
          }
        }, 300); // Adjust timing as needed based on the animation speed
      });
    });
  }

  function handleViewportChange(e) {
    if (e.matches) { // If the viewport matches mobile width
      handleAccordionClick();
    } else {
      // Remove event listeners if not on mobile
      document.querySelectorAll(".collapsible-trigger").forEach(trigger => {
        trigger.removeEventListener("click", handleAccordionClick);
      });
    }
  }

  mobileQuery.addListener(handleViewportChange); // Attach listener function on state changes
  handleViewportChange(mobileQuery); // Call listener function at run time
});

const scrollDebug = false;

document.addEventListener('DOMContentLoaded', function() {
  let lastColor = null;  // Variable to store the last scrolled-to color

  // Function to handle the scrolling of the image into view with custom offset
  function scrollToVariantImage(colorName) {
    if (scrollDebug) console.log(`TEST: changing to color ${colorName}`);

    // Check if the color has changed
    if (colorName === lastColor) {
      if (scrollDebug) console.log('Color has not changed, no scrolling needed.');
      return;  // Exit if the color hasn't changed
    }

    // Find all images on the product page
    const images = document.querySelectorAll('.product-media .image-element');

    // Find the first image whose alt text includes the color name
    const targetImage = Array.from(images).find(img => img.alt.toLowerCase().includes(colorName.toLowerCase()));

    // If the image is found, scroll it into view with offset
    if (targetImage) {
      const boundingRect = targetImage.getBoundingClientRect();
      const offset = window.innerWidth <= 768 ? 77 : 136; // Updated offsets for mobile and desktop
      const scrollToPosition = window.pageYOffset + boundingRect.top - offset;

      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });

      lastColor = colorName;  // Update the last color
    }
  }

  // DOMContentLoaded
  if (scrollDebug) console.log(`TEST document loaded`);
  // Find the dropdown with attribute data-index="option1" and get the selected color
  const colorDropdown = document.querySelector('select[data-index="option1"]');
  const selectedColor = colorDropdown ? colorDropdown.value : null;
  if (scrollDebug) console.log(`TEST selected color: ${selectedColor}`);
  if (selectedColor) {
    scrollToVariantImage(selectedColor);
  }

  // Event listener for the 'variant:change' event
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant && e.detail.variant.option1) {
      scrollToVariantImage(e.detail.variant.option1);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  function updateTime() {
    const now = new Date();
    const newYorkTime = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));
    const milanoTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Rome" }));

    const formatTime = (date) => {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    };

    if (document.getElementById("newYorkClock")) {
      document.getElementById("newYorkClock").innerHTML = `New York<br />${formatTime(newYorkTime)}`;
    }
    if (document.getElementById("milanoClock")) {
      document.getElementById("milanoClock").innerHTML = `Milano<br />${formatTime(milanoTime)}`;
    }
  }

  setInterval(updateTime, 1000);
  updateTime();
});